<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TVUCCr/tc-custom/9783985317691.jpg" alt="This image is the cover for the book Gobseck & At the Sign of the Cat and Racket, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gobseck & At the Sign of the Cat and Racket, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Gobseck, an 1830 novella by French author Honoré de Balzac (1799-1850), appears in the Scènes de la vie privée section of his novel sequence La Comédie humaine. Gobseck first appeared in outline form in La Mode in March 1830 under the title l'Usurier (The Usurer), and then in August 1830 in the periodical Le Voleur. The actual novella appeared in a volume published by Mame-Delaunay under the title Les Dangers de l'inconduite. This novella would appear in 1835 under the title of Papa Gobseck in a volume published by Madame Charles-Béchet. The definitive title of Gobseck originated in 1842 in the Furne edition of La Comédie humaine.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Honoré de Balzac
      </h2>
      
      <p class="authorDescription body article">Honoré de Balzac, (20 May 1799 – 18 August 1850) was a French novelist and playwright. The novel sequence La Comédie humaine, which presents a panorama of post-Napoleonic French life, is generally viewed as his magnum opus. Owing to his keen observation of detail and unfiltered representation of society, Balzac is regarded as one of the founders of realism in European literature. He is renowned for his multi-faceted characters; even his lesser characters are complex, morally ambiguous and fully human. Inanimate objects are imbued with character as well; the city of Paris, a backdrop for much of his writing, takes on many human qualities. His writing influenced many famous writers, including the novelists Émile Zola, Charles Dickens, Gustave Flaubert, and Henry James, and filmmakers François Truffaut and Jacques Rivette. Many of Balzac's works have been made into films and continue to inspire other writers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73d55cb8